import * as d3 from "d3";

export default class ColorRange {
  constructor(metric, min, max) {
    this.metric = metric;
    this.min = min;
    this.max = max;
    
    if (!["recency", "size", "origsize"].includes(this.metric)) {
      console.error("Invalid metric");
    }

    this.colorMap = [
      "#F07E2A",
      "#ffbf0d",
      "#ffe6a0"
    ].reverse();

    this.setScale();
  }
  setScale() {
    if (this.metric === "recency") {
      this.domain = [-3, 0, 3];
      this.scale = d3
        .scaleLinear()
        .domain(this.domain)
        .range(this.colorMap)
        .interpolate(d3.interpolateRgb)
        .clamp(true);
    }
    if (this.metric === "size" || this.metric === "origsize") {
      this.domain = [this.min, this.max];
      this.scale = d3
        .scaleLinear()
        .domain(this.domain)
        .range(['#2FFFE7', '#006f71'])
        //.range(['#efefef', '#2FFFE7'])
        .interpolate(d3.interpolate)
        .clamp(true);
    }
  }
  getColors(value) {
    if (this.metric === "recency") {
      if (value === "inf") {
        value = -3;
      }
      if (value === "-inf") {
        value = 3;
      }

      this.bgColor = this.scale(value);
    }

    if (this.metric === "size" || this.metric === "origsize") {
      //this.bgColor = d3.interpolateGreys(this.scale(value));
      this.bgColor = this.scale(value);
    }

    let parsed = this.bgColor
      .split("(")[1]
      .split(")")[0]
      .split(",");
    let yiq =
      (parseInt(parsed[0].trim()) * 299 +
        parseInt(parsed[1].trim()) * 587 +
        parseInt(parsed[2].trim()) * 114) /
      1000;
    this.textColor = yiq >= 128 ? "#333" : "#FFF";

    return {
      bgColor: this.bgColor,
      textColor: this.textColor
    };
  }
}
